import React, { useState } from 'react';
import { Button,  Label } from 'reactstrap';
import { Modal , Row ,Col } from 'react-bootstrap';
import Cookies from 'js-cookie';
import '../assets/css2/css/modal.css';
import '../assets/scss/style.scss';
import imageLogout from '../assets/icon/msg_error-0 1.png';
import { useHistory } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { updateUser } from 'slice/userSlice';
//API
import { SignOut } from 'actions/auth/index';
export default function LogoutModal() {
  const dispatch = useDispatch()
  const history = useHistory()

  const [show, setShow] = useState(false);
  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);
  const [state, setState] = useState(false);
  function openLogoutModal() {
    setState({
      logoutModal: !state.logoutModal,
    });
  }

  function Logout() {
    dispatch(SignOut()).then(response => {
      dispatch(updateUser(null))
      history.push('/login');
    }).catch((e) => {
      localStorage.removeItem('access_token');
      localStorage.removeItem('profile');
      localStorage.removeItem('userInfo');
      localStorage.removeItem('level');
      history.push('/login');
    })  
  }
  const closeBtn = (
    <Button
      type="button"
      className="close"
      aria-label="Close"
      onClick={openLogoutModal.bind(this)}
    >
      <img src="icon/close-icon.png" alt="" width="15" height="16" />
    </Button>
  );
  return (
    <>
      <Button
        className="logout-btn d-none d-lg-flex"
        onClick={handleShow}
      >
        <img src={imageLogout} alt="" /> ออกระบบ
      </Button>

      <Button
        className="dash-icon d-flex d-lg-none"
        onClick={handleShow}
      >
        <img src={imageLogout} className="icon" />
        <p className="p-1">ออกระบบ</p>
      </Button>

      <Modal
        id="_logout_modal"
        className="modal-Login"
        centered
        show={show}
        onHide={handleClose}
      >
        <Modal.Header className="modal-header-login">
          <p className="title-header">
            <b>ออกระบบ</b>
          </p>
          <button
            type="button"
            className="btn-close"
            data-dismiss="modal"
            aria-label="Close"
            onClick={handleClose}
          >
            <span aria-hidden="true">X</span>
          </button>
        </Modal.Header>
        <Modal.Body className="custom-setting set-logout-modal">
          <div className="logout-modal">
            <h5>คุณต้องการออกระบบหรือไม่</h5>
            <div className="confirm-logout">
              <Row>
              <Col className="mt-2 mb-2"> 
              <Button onClick={() => Logout()}>ใช่</Button>
              </Col>
              <Col className="mt-2 mb-2">
              <Button onClick={handleClose}>ไม่ใช่</Button>
              </Col>
              </Row>
            </div>
          </div>
        </Modal.Body>
      </Modal>
    </>
  );
}
